import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { routeNames } from '@shared/models';
import { SharedService } from '@shared/services';
import { Format } from '@app/models';
import { PortalService } from '@app/services';
import * as actions from '@app/store/list.actions';
import { SetItemPosition } from '@app/store/portal.actions';
import { PortalState } from '@app/store/portal.state';
import { ListState } from '@app/store/list.state';

@Component({
  selector: 'prp-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
})
export class ListItemComponent implements OnInit {
  @Input() format: Format;
  @ViewChild('el1', { static: true }) el2: ElementRef;
  @Select(PortalState.rtl2Employee)
  producer$: Observable<boolean>;
  @Select(ListState.searchResults) data$: Observable<Format[]>;

  private FORMAT_AUTOSELECT = 1;

  constructor(
    private store: Store,
    private sharedService: SharedService,
    private portalService: PortalService
  ) {}

  move(ref: ElementRef) {
    this.store.dispatch(new SetItemPosition(this.el2.nativeElement.offsetTop));
  }

  ngOnInit() {
    this.data$.pipe(take(1)).subscribe((data) => {
      if (data.length === this.FORMAT_AUTOSELECT) {
        this.triggerSelectFormat(data[0]);
      }
    });
  }

  selectFormat(format: Format) {
    this.portalService.checkNewFilePending([format], this.triggerSelectFormat.bind(this));
  }

  triggerSelectFormat(format: Format) {
    const id = format.contentFormatId?.toString() || null;

    if (!id || this.store.selectSnapshot(ListState.formatSelected) === id) {
      return;
    }

    this.store.dispatch(new actions.SetFormatSelected(id));

    this.sharedService.navigateBaseFirstCurrent({
      [routeNames.contentFormatId]: format.contentFormatId,
    });
  }
}
